/**
 * Which of a run's files is downloaded — picked by the route, never sent in the body.
 */
export enum RebateSubmissionFileKind {
	/**
	 * The debug CSV the generation proc's rows were exported to.
	 */
	Debug = 1,
	/**
	 * The production file, as the aggregator's builder shaped it.
	 */
	Production = 2,
	/**
	 * The PGP-encrypted copy of the production file, which only an aggregator with a PGP key gets.
	 */
	EncryptedProduction = 3
}
